function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12.001C0 5.37419 5.37321 0.000976562 12 0.000976562C18.6268 0.000976562 24 5.37419 24 12.001C24 18.6278 18.6268 24.001 12 24.001C5.37321 24.001 0 18.6278 0 12.001ZM2.03571 12.001C2.03571 17.5028 6.49821 21.9653 12 21.9653C17.5018 21.9653 21.9643 17.5028 21.9643 12.001C21.9643 6.49919 17.5018 2.03669 12 2.03669C6.49821 2.03669 2.03571 6.49919 2.03571 12.001ZM17.8064 8.59234C18.133 8.14697 18.0367 7.52117 17.5914 7.19457C17.146 6.86797 16.5202 6.96425 16.1936 7.40961L11.3829 13.9697L7.70711 10.2939C7.31658 9.90335 6.68342 9.90335 6.29289 10.2939C5.90237 10.6844 5.90237 11.3176 6.29289 11.7081L10.7929 16.2081C10.9992 16.4144 11.2853 16.5203 11.5763 16.4981C11.8672 16.4758 12.1339 16.3276 12.3064 16.0923L17.8064 8.59234Z",
  fill: "var(--k-fg-3cc13b)"
});

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.65cb950c.svg";
export { ForwardRef as ReactComponent };